module.exports = __webpack_public_path__ + "media/snow-falling.7d6eb41b.mp4";